import { onError } from '@apollo/client/link/error';

import handleUnauthorizedError from './handleUnauthorizedError';

const errorLink = onError(({
  graphQLErrors, networkError, operation, forward
// eslint-disable-next-line consistent-return
}) => {
  if (graphQLErrors) {
    const error = graphQLErrors[0];

    if (error?.message === 'Unauthorized') {
      return handleUnauthorizedError(operation, forward);
    }
  }

  if (networkError) console.log(`[Network error]: ${networkError}`);
});

export default errorLink;
